import axios from "axios";
import { createDatabase, storeDataInIndexedDB } from "../Hooks/IndexedDBUtils";

const { REACT_APP_BASE_URL } = process.env;

export const MEETING_STORE = "syncableMeetingStore";
export const syncableMeetingDB = createDatabase("syncableMeetingDB", MEETING_STORE);

export const queueMeetingOffline = async (data) => {
  // The store is keyed by id and meetings have none, so each queued entry gets a unique local key
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  await storeDataInIndexedDB(syncableMeetingDB, MEETING_STORE, [{ id, ...data }]);
  return id;
};

// Resolves offline=true when the meeting was queued instead of posted
export const submitMeetingLog = async (data, token) => {
  if (navigator.onLine === false) {
    await queueMeetingOffline(data);
    return { offline: true };
  }
  const response = await axios.post(`${REACT_APP_BASE_URL}/logMeeting`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return { offline: false, response };
};

export const syncMeetingCallApi = async (meeting, token) => {
  const { id, ...data } = meeting;
  try {
    await axios.post(`${REACT_APP_BASE_URL}/logMeeting`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return true;
  } catch (error) {
    console.log("Error occurred while syncing meeting:", error);
    return false;
  }
};
